import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AddButtonComponent } from '@shared/components/add-button/add-button.component';
import { AdviceComponent } from '@shared/components/advice/advice.component';
import { BackButtonSmallComponent } from '@shared/components/back-button-small/back-button-small.component';
import { BackButtonComponent } from '@shared/components/back-button/back-button.component';
import { ButtonComponent } from '@shared/components/button/button.component';
import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { InputCurrencyComponent } from '@shared/components/input-currency/input-currency.component';
import { InputComponent } from '@shared/components/input/input.component';
import { RadioButtonComponent } from '@shared/components/radio-button/radio-button.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { StepperComponent } from '@shared/components/stepper/stepper.component';
import { SwitchComponent } from '@shared/components/switch/switch.component';
import { OutsideDirective } from '@shared/directives/outside.directive';
import { LayoutComponent } from '@shared/layout/layout.component';
import { NgxMaskModule } from 'ngx-mask';
import { AlertComponent } from './components/alert/alert.component';
import { AmountCurrencyComponent } from './components/amount-currency/amount-currency.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BubbleComponent } from './components/bubble/bubble.component';
import { CircularIndicatorComponent } from './components/circular-indicator/circular-indicator.component';
import { DynamicListComponent } from './components/dynamic-list/dynamic-list.component';
import { CategoryButtonComponent } from './components/menu/category-button/category-button.component';
import { MenuComponent } from './components/menu/menu.component';
import { NumberSelectorComponent } from './components/number-selector/number-selector.component';
import { ScrollButtonComponent } from './components/scroll-button/scroll-button.component';
import { SelectCurrencyComponent } from './components/select-currency/select-currency.component';
import { SelectRadioComponent } from './components/select-radio/select-radio.component';
import { SliderComponent } from './components/slider/slider.component';
import { StepperSmallComponent } from './components/stepper-small/stepper-small.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { InvalidFormScrollDirective } from './directives/invalid-form-scroll.directive';
import { LazyImageDirective } from './directives/lazy-image.directive';
import { LongPressDirective } from './directives/long-press.directive';
import { NgModelChangeDebounceDirective } from './directives/ng-model-change-debounce.directive';
import { ScrollContainerDirective } from './directives/scroll-container.directive';
import { ValueChangeDebounceDirective } from './directives/value-change-debounce.directive';
import { VisibilityOnScrollDirective } from './directives/visibility-on-scroll.directive';
import { FuturePlanComponent } from './forms/components/future-plan/future-plan.component';
import { LoanComponent } from './forms/components/loan/loan.component';
import { RelatedPersonComponent } from './forms/components/related-person/related-person.component';
import { SavingOrInvestmentComponent } from './forms/components/saving-or-investment/saving-or-investment.component';
import { SpecificExpenditureComponent } from './forms/components/specific-expenditure/specific-expenditure.component';
import { ConfigCurrencyPipe } from './pipes/default-currency.pipe';

const GLOBAL_DECLARATIONS = [
  // Layouts
  LayoutComponent,
  // Components
  ButtonComponent,
  AdviceComponent,
  ChipComponent,
  InputComponent,
  SwitchComponent,
  HeaderComponent,
  FooterComponent,
  BackButtonComponent,
  BackButtonSmallComponent,
  AddButtonComponent,
  RadioButtonComponent,
  CheckboxComponent,
  StepperComponent,
  SelectComponent,
  SelectCurrencyComponent,
  StepperSmallComponent,
  InputCurrencyComponent,
  DynamicListComponent,
  CircularIndicatorComponent,
  MenuComponent,
  CategoryButtonComponent,
  BubbleComponent,
  BreadcrumbComponent,
  SliderComponent,
  ScrollButtonComponent,
  TabsComponent,
  AlertComponent,
  SelectRadioComponent,
  NumberSelectorComponent,
  AmountCurrencyComponent,
  // Outside
  OutsideDirective,
  // Scroll
  ScrollContainerDirective,
  InvalidFormScrollDirective,
  VisibilityOnScrollDirective,
  // Debounce
  ValueChangeDebounceDirective,
  NgModelChangeDebounceDirective,
  LongPressDirective,
  // Directives
  LazyImageDirective,
  // Pipes
  ConfigCurrencyPipe
];

const FORMS_DECLARATIONS = [
  // Components
  SavingOrInvestmentComponent,
  RelatedPersonComponent,
  FuturePlanComponent,
  LoanComponent,
  SpecificExpenditureComponent
];

const MODULES = [TranslateModule, NgxMaskModule];

@NgModule({
  declarations: [...GLOBAL_DECLARATIONS],
  imports: [CommonModule, FormsModule, OverlayModule, ...MODULES],
  exports: [...GLOBAL_DECLARATIONS, ...MODULES],
  providers: [ConfigCurrencyPipe]
})
export class SharedModule {}

/**
 * This module exports the functionality of the SharedModule plus the ReactiveFormsModule
 * and components that use the ReactiveFormsModule's FormGroups, etc.
 */
@NgModule({
  declarations: [...FORMS_DECLARATIONS],
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule],
  exports: [...FORMS_DECLARATIONS, SharedModule, ReactiveFormsModule]
})
export class SharedFormsModule {}
